module.exports = { id: "breaks", url: "/build/app/img/symbols.svg#breaks", viewBox: "", toString: function() { return this.url; } };